/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitOauthCodes} from '../api'

export const useMutationSubmitOauthCodes = createReactQueryMutationHook('submitOauthCodes', submitOauthCodes)
